import { render, staticRenderFns } from "./AttachmentsProfile.vue?vue&type=template&id=7510cdb0&"
import script from "./AttachmentsProfile.vue?vue&type=script&setup=true&lang=js&"
export * from "./AttachmentsProfile.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports